import React from "react";
import { ReactComponent as AlertIcon } from "go-core/images/svg/alert.svg";

export interface DashboardAlertRowContentProps {
	title: string;
	value?: string | number;
}

export const DashboardAlertRowContent = ({ title, value }: DashboardAlertRowContentProps) => {
	if (value === undefined || value === null || value === "") {
		return null;
	}

	return (
		<span className="d-flex align-items-center gap-2">
			<AlertIcon />
			{title}: {value}
		</span>
	);
};
